import { http } from '@/utils/http'
export const QCBASE = window.$envUtils('VUE_APP_QC_SERVICE')

/**
 * 会话日志（分页列表）
 * @param {*} params
 */
export const getSessionLogList = (params) => {
  return http.get(`${QCBASE}/mgr/realTimeReport/qcLog`, { params })
}
/**
 * 会话明细
 * @param {*} params
 */
export const getChatLogList = (params) => {
  return http.get(`${QCBASE}/mgr/realTimeReport/qcLog/sessionDetail`, { params })
}
/**
 * 附件下载
 * @param {*} params
 */
export const downloadFile = (params) => {
  return http.get(`${QCBASE}/mgr/realTimeReport/qcLog/downloadFile?path=` + params, { responseType: 'blob' })
}
